export const mobileBreakPoint = "M";